/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=regular&m=free */

import { faArrowAltCircleDown, faBell, faCheckCircle, faCopy, faCreditCard, faEdit, faFlag, faMoneyBill1, faMoneyBillAlt, faTrashCan, faUserCircle } from '@fortawesome/free-regular-svg-icons';

export const fontAwesomeRegularIcons = {
    faArrowAltCircleDown,
    faBell,
    faCheckCircle,
    faCopy,
    faCreditCard,
    faUserCircle,
    faFlag,
    faTrashCan,
    faEdit,
    faMoneyBill1,
    faMoneyBillAlt,
};
